import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import { Paragraph } from "@twilio-paste/core/paragraph";
import React from "react";
import HomeGetStarted from "../../../assets/icons/get-started-running.svg";
import { GetStartedCard, GetStartedCardIllustration, GetStartedCardLink } from "../GetStartedCard";

interface GetStartedRunningProps {
    animationDelay: number;
}

export const GetStartedRunning: React.FC<GetStartedRunningProps> = ({ animationDelay }) => (
    <GetStartedCard animationDelay={animationDelay}>
        <Box display="flex" height="100%" flexDirection="column" justifyContent="space-between">
            <div>
                <GetStartedCardIllustration>
                    <HomeGetStarted aria-hidden="true" />
                </GetStartedCardIllustration>
                <Heading as="h2" variant="heading30">
                    What else?
                </Heading>
                <Paragraph>
                    You can also customize themes and styles, change template strings, customize notifications and much
                    more
                </Paragraph>
            </div>
            <GetStartedCardLink to="/overview/Manager">Start exploring</GetStartedCardLink>
        </Box>
    </GetStartedCard>
);
